import styled from 'styled-components'

interface ISpendTrackerUncategorizedCardStyledProps {}

export const SpendTrackerUncategorizedCardStyled = styled.div<ISpendTrackerUncategorizedCardStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
